import { render, staticRenderFns } from "./AccountSummary.vue?vue&type=template&id=64d24c3e"
import script from "./AccountSummary.vue?vue&type=script&lang=js"
export * from "./AccountSummary.vue?vue&type=script&lang=js"
import style0 from "./AccountSummary.vue?vue&type=style&index=0&id=64d24c3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports